// Copyright 2025, compose-coui-ui contributors
// SPDX-License-Identifier: Apache-2.0

package io.github.suqi8.coui.kmp.icon.extended

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathNode
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.unit.dp
import io.github.suqi8.coui.kmp.icon.COUIIcons

val COUIIcons.Tune: ImageVector
    get() = COUIIcons.Regular.Tune

val COUIIcons.Light.Tune: ImageVector
    get() {
        if (_tuneLight != null) return _tuneLight!!
        _tuneLight = ImageVector.Builder(
            name = "Tune.Light",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1183.2f,
            viewportHeight = 1183.2f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1183.2f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(587.6f, 301.9f),
                        PathNode.QuadTo(587.6f, 347.6f, 565.1f, 385.6f),
                        PathNode.QuadTo(542.6f, 423.6f, 504.6f, 446.1f),
                        PathNode.QuadTo(466.6f, 468.6f, 420.9f, 468.6f),
                        PathNode.QuadTo(375.1f, 468.6f, 336.9f, 446.1f),
                        PathNode.QuadTo(298.6f, 423.6f, 276.1f, 385.3f),
                        PathNode.QuadTo(253.6f, 347.0f, 253.6f, 301.8f),
                        PathNode.QuadTo(253.6f, 256.6f, 276.1f, 218.1f),
                        PathNode.QuadTo(298.6f, 179.6f, 337.1f, 157.1f),
                        PathNode.QuadTo(375.6f, 134.6f, 420.8f, 134.6f),
                        PathNode.QuadTo(466.0f, 134.6f, 504.3f, 157.1f),
                        PathNode.QuadTo(542.6f, 179.6f, 565.1f, 217.9f),
                        PathNode.QuadTo(587.6f, 256.1f, 587.6f, 301.9f),
                        PathNode.Close,
                        PathNode.MoveTo(313.6f, 301.6f),
                        PathNode.QuadTo(313.6f, 346.6f, 344.8f, 378.1f),
                        PathNode.QuadTo(376.0f, 409.6f, 420.2f, 409.6f),
                        PathNode.QuadTo(465.6f, 409.6f, 497.1f, 378.1f),
                        PathNode.QuadTo(528.6f, 346.6f, 528.6f, 301.6f),
                        PathNode.QuadTo(528.6f, 256.6f, 497.2f, 225.1f),
                        PathNode.QuadTo(465.8f, 193.6f, 420.1f, 193.6f),
                        PathNode.QuadTo(375.6f, 193.6f, 344.6f, 225.1f),
                        PathNode.QuadTo(313.6f, 256.6f, 313.6f, 301.6f),
                        PathNode.Close,
                        PathNode.MoveTo(287.6f, 331.6f),
                        PathNode.HorizontalTo(117.6f),
                        PathNode.QuadTo(109.6f, 331.6f, 104.1f, 326.9f),
                        PathNode.QuadTo(98.6f, 322.1f, 98.6f, 310.6f),
                        PathNode.VerticalTo(293.6f),
                        PathNode.QuadTo(98.6f, 282.6f, 104.0f, 277.6f),
                        PathNode.QuadTo(109.5f, 272.6f, 117.6f, 272.6f),
                        PathNode.HorizontalTo(287.6f),
                        PathNode.Close,
                        PathNode.MoveTo(1084.6f, 293.6f),
                        PathNode.VerticalTo(310.3f),
                        PathNode.QuadTo(1084.6f, 322.6f, 1079.1f, 327.1f),
                        PathNode.QuadTo(1073.6f, 331.6f, 1065.6f, 331.6f),
                        PathNode.HorizontalTo(558.6f),
                        PathNode.VerticalTo(271.6f),
                        PathNode.LineTo(1065.6f, 272.6f),
                        PathNode.QuadTo(1073.7f, 272.6f, 1079.2f, 277.6f),
                        PathNode.QuadTo(1084.6f, 282.6f, 1084.6f, 293.6f),
                        PathNode.Close,
                        PathNode.MoveTo(1084.6f, 873.6f),
                        PathNode.VerticalTo(890.3f),
                        PathNode.QuadTo(1084.6f, 902.6f, 1079.1f, 907.1f),
                        PathNode.QuadTo(1073.6f, 911.6f, 1065.6f, 911.6f),
                        PathNode.HorizontalTo(895.6f),
                        PathNode.VerticalTo(852.6f),
                        PathNode.HorizontalTo(1065.6f),
                        PathNode.QuadTo(1073.7f, 852.6f, 1079.2f, 857.6f),
                        PathNode.QuadTo(1084.6f, 862.6f, 1084.6f, 873.6f),
                        PathNode.Close,
                        PathNode.MoveTo(620.6f, 911.6f),
                        PathNode.HorizontalTo(117.6f),
                        PathNode.QuadTo(109.6f, 911.6f, 104.1f, 906.6f),
                        PathNode.QuadTo(98.6f, 901.6f, 98.6f, 890.6f),
                        PathNode.VerticalTo(873.6f),
                        PathNode.QuadTo(98.6f, 862.6f, 104.0f, 857.6f),
                        PathNode.QuadTo(109.5f, 852.6f, 117.6f, 852.6f),
                        PathNode.HorizontalTo(620.6f),
                        PathNode.Close,
                        PathNode.MoveTo(927.6f, 881.9f),
                        PathNode.QuadTo(927.6f, 927.6f, 905.1f, 965.6f),
                        PathNode.QuadTo(882.6f, 1003.6f, 844.5f, 1026.1f),
                        PathNode.QuadTo(806.5f, 1048.6f, 761.5f, 1048.6f),
                        PathNode.QuadTo(716.6f, 1048.6f, 678.1f, 1026.1f),
                        PathNode.QuadTo(639.6f, 1003.6f, 617.1f, 965.3f),
                        PathNode.QuadTo(594.6f, 927.0f, 594.6f, 881.8f),
                        PathNode.QuadTo(594.6f, 836.6f, 617.1f, 798.1f),
                        PathNode.QuadTo(639.6f, 759.6f, 678.1f, 737.1f),
                        PathNode.QuadTo(716.6f, 714.6f, 761.5f, 714.6f),
                        PathNode.QuadTo(806.5f, 714.6f, 844.5f, 737.1f),
                        PathNode.QuadTo(882.6f, 759.6f, 905.1f, 797.9f),
                        PathNode.QuadTo(927.6f, 836.1f, 927.6f, 881.9f),
                        PathNode.Close,
                        PathNode.MoveTo(653.6f, 881.4f),
                        PathNode.QuadTo(653.6f, 925.6f, 685.2f, 957.6f),
                        PathNode.QuadTo(716.8f, 989.6f, 761.6f, 989.6f),
                        PathNode.QuadTo(807.1f, 989.6f, 838.3f, 957.8f),
                        PathNode.QuadTo(869.6f, 926.1f, 869.6f, 881.8f),
                        PathNode.QuadTo(869.6f, 837.6f, 838.2f, 805.6f),
                        PathNode.QuadTo(806.8f, 773.6f, 761.1f, 773.6f),
                        PathNode.QuadTo(716.6f, 773.6f, 685.1f, 805.4f),
                        PathNode.QuadTo(653.6f, 837.1f, 653.6f, 881.4f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _tuneLight!!
    }

private var _tuneLight: ImageVector? = null

val COUIIcons.Normal.Tune: ImageVector
    get() {
        if (_tuneNormal != null) return _tuneNormal!!
        _tuneNormal = ImageVector.Builder(
            name = "Tune.Normal",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1183.2f,
            viewportHeight = 1183.2f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1183.2f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(596.5f, 301.7f),
                        PathNode.QuadTo(596.5f, 349.7f, 573.0f, 390.1f),
                        PathNode.QuadTo(549.5f, 430.5f, 509.1f, 454.0f),
                        PathNode.QuadTo(468.7f, 477.5f, 420.7f, 477.5f),
                        PathNode.QuadTo(372.7f, 477.5f, 332.6f, 454.0f),
                        PathNode.QuadTo(292.4f, 430.5f, 268.5f, 390.0f),
                        PathNode.QuadTo(244.7f, 349.5f, 244.7f, 301.7f),
                        PathNode.QuadTo(244.7f, 253.9f, 268.5f, 213.6f),
                        PathNode.QuadTo(292.4f, 173.4f, 332.6f, 149.5f),
                        PathNode.QuadTo(372.9f, 125.7f, 420.7f, 125.7f),
                        PathNode.QuadTo(468.5f, 125.7f, 509.0f, 149.5f),
                        PathNode.QuadTo(549.5f, 173.4f, 573.0f, 213.6f),
                        PathNode.QuadTo(596.5f, 253.7f, 596.5f, 301.7f),
                        PathNode.Close,
                        PathNode.MoveTo(322.5f, 301.6f),
                        PathNode.QuadTo(322.5f, 342.5f, 351.2f, 371.6f),
                        PathNode.QuadTo(379.8f, 400.7f, 420.5f, 400.7f),
                        PathNode.QuadTo(462.2f, 400.7f, 490.9f, 371.6f),
                        PathNode.QuadTo(519.7f, 342.5f, 519.7f, 301.6f),
                        PathNode.QuadTo(519.7f, 260.7f, 490.9f, 231.6f),
                        PathNode.QuadTo(462.2f, 202.5f, 420.5f, 202.5f),
                        PathNode.QuadTo(379.7f, 202.5f, 351.1f, 231.6f),
                        PathNode.QuadTo(322.5f, 260.7f, 322.5f, 301.6f),
                        PathNode.Close,
                        PathNode.MoveTo(290.4f, 340.5f),
                        PathNode.HorizontalTo(123.8f),
                        PathNode.QuadTo(113.7f, 340.5f, 106.2f, 334.2f),
                        PathNode.QuadTo(98.6f, 327.9f, 98.6f, 312.7f),
                        PathNode.VerticalTo(291.5f),
                        PathNode.QuadTo(98.6f, 276.4f, 105.8f, 270.0f),
                        PathNode.QuadTo(113.0f, 263.7f, 123.8f, 263.7f),
                        PathNode.HorizontalTo(290.4f),
                        PathNode.Close,
                        PathNode.MoveTo(1084.6f, 291.5f),
                        PathNode.VerticalTo(312.6f),
                        PathNode.QuadTo(1084.6f, 328.1f, 1077.0f, 334.3f),
                        PathNode.QuadTo(1069.5f, 340.5f, 1059.4f, 340.5f),
                        PathNode.HorizontalTo(558.6f),
                        PathNode.VerticalTo(262.7f),
                        PathNode.LineTo(1059.4f, 263.7f),
                        PathNode.QuadTo(1070.2f, 263.7f, 1077.4f, 270.0f),
                        PathNode.QuadTo(1084.6f, 276.4f, 1084.6f, 291.5f),
                        PathNode.Close,
                        PathNode.MoveTo(1084.6f, 871.5f),
                        PathNode.VerticalTo(892.6f),
                        PathNode.QuadTo(1084.6f, 908.1f, 1077.0f, 914.3f),
                        PathNode.QuadTo(1069.5f, 920.5f, 1059.4f, 920.5f),
                        PathNode.HorizontalTo(892.9f),
                        PathNode.VerticalTo(843.7f),
                        PathNode.HorizontalTo(1059.4f),
                        PathNode.QuadTo(1070.2f, 843.7f, 1077.4f, 850.0f),
                        PathNode.QuadTo(1084.6f, 856.4f, 1084.6f, 871.5f),
                        PathNode.Close,
                        PathNode.MoveTo(623.4f, 920.5f),
                        PathNode.HorizontalTo(123.8f),
                        PathNode.QuadTo(113.7f, 920.5f, 106.2f, 914.2f),
                        PathNode.QuadTo(98.6f, 907.8f, 98.6f, 892.7f),
                        PathNode.VerticalTo(871.5f),
                        PathNode.QuadTo(98.6f, 856.4f, 105.8f, 850.0f),
                        PathNode.QuadTo(113.0f, 843.7f, 123.8f, 843.7f),
                        PathNode.HorizontalTo(623.4f),
                        PathNode.Close,
                        PathNode.MoveTo(937.2f, 881.7f),
                        PathNode.QuadTo(937.2f, 929.7f, 913.7f, 970.1f),
                        PathNode.QuadTo(890.2f, 1010.5f, 849.7f, 1034.0f),
                        PathNode.QuadTo(809.3f, 1057.5f, 761.6f, 1057.5f),
                        PathNode.QuadTo(713.9f, 1057.5f, 673.6f, 1034.0f),
                        PathNode.QuadTo(633.4f, 1010.5f, 609.5f, 970.0f),
                        PathNode.QuadTo(585.7f, 929.5f, 585.7f, 881.7f),
                        PathNode.QuadTo(585.7f, 833.9f, 609.5f, 793.6f),
                        PathNode.QuadTo(633.4f, 753.4f, 673.6f, 729.5f),
                        PathNode.QuadTo(713.9f, 705.7f, 761.6f, 705.7f),
                        PathNode.QuadTo(809.3f, 705.7f, 849.7f, 729.5f),
                        PathNode.QuadTo(890.2f, 753.4f, 913.7f, 793.6f),
                        PathNode.QuadTo(937.2f, 833.7f, 937.2f, 881.7f),
                        PathNode.Close,
                        PathNode.MoveTo(663.2f, 881.5f),
                        PathNode.QuadTo(663.2f, 922.2f, 692.0f, 951.4f),
                        PathNode.QuadTo(720.8f, 980.7f, 761.6f, 980.7f),
                        PathNode.QuadTo(803.3f, 980.7f, 832.0f, 951.5f),
                        PathNode.QuadTo(860.7f, 922.3f, 860.7f, 881.7f),
                        PathNode.QuadTo(860.7f, 841.0f, 831.9f, 811.8f),
                        PathNode.QuadTo(803.2f, 782.5f, 761.5f, 782.5f),
                        PathNode.QuadTo(720.7f, 782.5f, 692.0f, 811.7f),
                        PathNode.QuadTo(663.2f, 840.9f, 663.2f, 881.5f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _tuneNormal!!
    }

private var _tuneNormal: ImageVector? = null

val COUIIcons.Regular.Tune: ImageVector
    get() {
        if (_tuneRegular != null) return _tuneRegular!!
        _tuneRegular = ImageVector.Builder(
            name = "Tune.Regular",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1183.2f,
            viewportHeight = 1183.2f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1183.2f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(600.6f, 301.6f),
                        PathNode.QuadTo(600.6f, 350.6f, 576.6f, 392.1f),
                        PathNode.QuadTo(552.6f, 433.6f, 511.1f, 457.6f),
                        PathNode.QuadTo(469.6f, 481.6f, 420.6f, 481.6f),
                        PathNode.QuadTo(371.6f, 481.6f, 330.6f, 457.6f),
                        PathNode.QuadTo(289.6f, 433.6f, 265.1f, 392.1f),
                        PathNode.QuadTo(240.6f, 350.6f, 240.6f, 301.6f),
                        PathNode.QuadTo(240.6f, 252.6f, 265.1f, 211.6f),
                        PathNode.QuadTo(289.6f, 170.6f, 330.6f, 146.1f),
                        PathNode.QuadTo(371.6f, 121.6f, 420.6f, 121.6f),
                        PathNode.QuadTo(469.6f, 121.6f, 511.1f, 146.1f),
                        PathNode.QuadTo(552.6f, 170.6f, 576.6f, 211.6f),
                        PathNode.QuadTo(600.6f, 252.6f, 600.6f, 301.6f),
                        PathNode.Close,
                        PathNode.MoveTo(326.6f, 301.6f),
                        PathNode.QuadTo(326.6f, 340.6f, 354.1f, 368.6f),
                        PathNode.QuadTo(381.6f, 396.6f, 420.6f, 396.6f),
                        PathNode.QuadTo(460.6f, 396.6f, 488.1f, 368.6f),
                        PathNode.QuadTo(515.6f, 340.6f, 515.6f, 301.6f),
                        PathNode.QuadTo(515.6f, 262.6f, 488.1f, 234.6f),
                        PathNode.QuadTo(460.6f, 206.6f, 420.6f, 206.6f),
                        PathNode.QuadTo(381.6f, 206.6f, 354.1f, 234.6f),
                        PathNode.QuadTo(326.6f, 262.6f, 326.6f, 301.6f),
                        PathNode.Close,
                        PathNode.MoveTo(291.6f, 344.6f),
                        PathNode.HorizontalTo(126.6f),
                        PathNode.QuadTo(115.6f, 344.6f, 107.1f, 337.6f),
                        PathNode.QuadTo(98.6f, 330.6f, 98.6f, 313.6f),
                        PathNode.VerticalTo(290.6f),
                        PathNode.QuadTo(98.6f, 273.6f, 106.6f, 266.6f),
                        PathNode.QuadTo(114.6f, 259.6f, 126.6f, 259.6f),
                        PathNode.HorizontalTo(291.6f),
                        PathNode.Close,
                        PathNode.MoveTo(1084.6f, 290.6f),
                        PathNode.VerticalTo(313.6f),
                        PathNode.QuadTo(1084.6f, 330.6f, 1076.1f, 337.6f),
                        PathNode.QuadTo(1067.6f, 344.6f, 1056.6f, 344.6f),
                        PathNode.HorizontalTo(558.6f),
                        PathNode.VerticalTo(258.6f),
                        PathNode.LineTo(1056.6f, 259.6f),
                        PathNode.QuadTo(1068.6f, 259.6f, 1076.6f, 266.6f),
                        PathNode.QuadTo(1084.6f, 273.6f, 1084.6f, 290.6f),
                        PathNode.Close,
                        PathNode.MoveTo(1084.6f, 870.6f),
                        PathNode.VerticalTo(893.6f),
                        PathNode.QuadTo(1084.6f, 910.6f, 1076.1f, 917.6f),
                        PathNode.QuadTo(1067.6f, 924.6f, 1056.6f, 924.6f),
                        PathNode.HorizontalTo(891.6f),
                        PathNode.VerticalTo(839.6f),
                        PathNode.HorizontalTo(1056.6f),
                        PathNode.QuadTo(1068.6f, 839.6f, 1076.6f, 846.6f),
                        PathNode.QuadTo(1084.6f, 853.6f, 1084.6f, 870.6f),
                        PathNode.Close,
                        PathNode.MoveTo(624.6f, 924.6f),
                        PathNode.HorizontalTo(126.6f),
                        PathNode.QuadTo(115.6f, 924.6f, 107.1f, 917.6f),
                        PathNode.QuadTo(98.6f, 910.6f, 98.6f, 893.6f),
                        PathNode.VerticalTo(870.6f),
                        PathNode.QuadTo(98.6f, 853.6f, 106.6f, 846.6f),
                        PathNode.QuadTo(114.6f, 839.6f, 126.6f, 839.6f),
                        PathNode.HorizontalTo(624.6f),
                        PathNode.Close,
                        PathNode.MoveTo(941.6f, 881.6f),
                        PathNode.QuadTo(941.6f, 930.6f, 917.6f, 972.1f),
                        PathNode.QuadTo(893.6f, 1013.6f, 852.1f, 1037.6f),
                        PathNode.QuadTo(810.6f, 1061.6f, 761.6f, 1061.6f),
                        PathNode.QuadTo(712.6f, 1061.6f, 671.6f, 1037.6f),
                        PathNode.QuadTo(630.6f, 1013.6f, 606.1f, 972.1f),
                        PathNode.QuadTo(581.6f, 930.6f, 581.6f, 881.6f),
                        PathNode.QuadTo(581.6f, 832.6f, 606.1f, 791.6f),
                        PathNode.QuadTo(630.6f, 750.6f, 671.6f, 726.1f),
                        PathNode.QuadTo(712.6f, 701.6f, 761.6f, 701.6f),
                        PathNode.QuadTo(810.6f, 701.6f, 852.1f, 726.1f),
                        PathNode.QuadTo(893.6f, 750.6f, 917.6f, 791.6f),
                        PathNode.QuadTo(941.6f, 832.6f, 941.6f, 881.6f),
                        PathNode.Close,
                        PathNode.MoveTo(667.6f, 881.6f),
                        PathNode.QuadTo(667.6f, 920.6f, 695.1f, 948.6f),
                        PathNode.QuadTo(722.6f, 976.6f, 761.6f, 976.6f),
                        PathNode.QuadTo(801.6f, 976.6f, 829.1f, 948.6f),
                        PathNode.QuadTo(856.6f, 920.6f, 856.6f, 881.6f),
                        PathNode.QuadTo(856.6f, 842.6f, 829.1f, 814.6f),
                        PathNode.QuadTo(801.6f, 786.6f, 761.6f, 786.6f),
                        PathNode.QuadTo(722.6f, 786.6f, 695.1f, 814.6f),
                        PathNode.QuadTo(667.6f, 842.6f, 667.6f, 881.6f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _tuneRegular!!
    }

private var _tuneRegular: ImageVector? = null

val COUIIcons.Medium.Tune: ImageVector
    get() {
        if (_tuneMedium != null) return _tuneMedium!!
        _tuneMedium = ImageVector.Builder(
            name = "Tune.Medium",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1203.0f,
            viewportHeight = 1203.0f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1203.0f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(618.7f, 311.8f),
                        PathNode.QuadTo(618.7f, 362.8f, 593.6f, 406.2f),
                        PathNode.QuadTo(568.5f, 449.6f, 525.1f, 474.6f),
                        PathNode.QuadTo(481.7f, 499.7f, 430.5f, 499.7f),
                        PathNode.QuadTo(379.7f, 499.7f, 336.7f, 474.6f),
                        PathNode.QuadTo(293.7f, 449.5f, 268.0f, 406.1f),
                        PathNode.QuadTo(242.2f, 362.7f, 242.2f, 311.5f),
                        PathNode.QuadTo(242.2f, 260.7f, 268.0f, 217.7f),
                        PathNode.QuadTo(293.7f, 174.7f, 336.7f, 149.0f),
                        PathNode.QuadTo(379.7f, 123.2f, 430.8f, 123.2f),
                        PathNode.QuadTo(481.8f, 123.2f, 525.2f, 149.0f),
                        PathNode.QuadTo(568.6f, 174.7f, 593.6f, 217.7f),
                        PathNode.QuadTo(618.7f, 260.7f, 618.7f, 311.8f),
                        PathNode.Close,
                        PathNode.MoveTo(343.5f, 311.5f),
                        PathNode.QuadTo(343.5f, 347.5f, 369.0f, 373.5f),
                        PathNode.QuadTo(394.4f, 399.4f, 430.5f, 399.4f),
                        PathNode.QuadTo(467.5f, 399.4f, 493.0f, 373.8f),
                        PathNode.QuadTo(518.4f, 348.1f, 518.4f, 311.8f),
                        PathNode.QuadTo(518.4f, 275.4f, 493.0f, 249.5f),
                        PathNode.QuadTo(467.5f, 223.5f, 430.5f, 223.5f),
                        PathNode.QuadTo(394.4f, 223.5f, 369.0f, 249.5f),
                        PathNode.QuadTo(343.5f, 275.4f, 343.5f, 311.5f),
                        PathNode.Close,
                        PathNode.MoveTo(309.7f, 362.7f),
                        PathNode.HorizontalTo(136.5f),
                        PathNode.QuadTo(122.2f, 362.7f, 111.2f, 353.4f),
                        PathNode.QuadTo(100.2f, 344.0f, 100.2f, 323.5f),
                        PathNode.VerticalTo(300.5f),
                        PathNode.QuadTo(100.2f, 280.0f, 110.6f, 270.6f),
                        PathNode.QuadTo(121.0f, 261.2f, 136.5f, 261.2f),
                        PathNode.HorizontalTo(309.7f),
                        PathNode.Close,
                        PathNode.MoveTo(1102.7f, 300.5f),
                        PathNode.VerticalTo(323.5f),
                        PathNode.QuadTo(1102.7f, 344.0f, 1091.7f, 353.4f),
                        PathNode.QuadTo(1080.7f, 362.7f, 1066.5f, 362.7f),
                        PathNode.HorizontalTo(560.2f),
                        PathNode.VerticalTo(260.2f),
                        PathNode.LineTo(1066.5f, 261.2f),
                        PathNode.QuadTo(1082.0f, 261.2f, 1092.4f, 270.6f),
                        PathNode.QuadTo(1102.7f, 280.0f, 1102.7f, 300.5f),
                        PathNode.Close,
                        PathNode.MoveTo(1102.7f, 880.5f),
                        PathNode.VerticalTo(903.5f),
                        PathNode.QuadTo(1102.7f, 924.0f, 1091.7f, 933.4f),
                        PathNode.QuadTo(1080.7f, 942.7f, 1066.5f, 942.7f),
                        PathNode.HorizontalTo(893.2f),
                        PathNode.VerticalTo(841.2f),
                        PathNode.HorizontalTo(1066.5f),
                        PathNode.QuadTo(1082.0f, 841.2f, 1092.4f, 850.6f),
                        PathNode.QuadTo(1102.7f, 860.0f, 1102.7f, 880.5f),
                        PathNode.Close,
                        PathNode.MoveTo(642.7f, 942.7f),
                        PathNode.HorizontalTo(136.5f),
                        PathNode.QuadTo(122.2f, 942.7f, 111.2f, 933.4f),
                        PathNode.QuadTo(100.2f, 924.0f, 100.2f, 903.5f),
                        PathNode.VerticalTo(880.5f),
                        PathNode.QuadTo(100.2f, 860.0f, 110.6f, 850.6f),
                        PathNode.QuadTo(121.0f, 841.2f, 136.5f, 841.2f),
                        PathNode.HorizontalTo(642.7f),
                        PathNode.Close,
                        PathNode.MoveTo(959.7f, 891.8f),
                        PathNode.QuadTo(959.7f, 942.8f, 934.6f, 986.2f),
                        PathNode.QuadTo(909.5f, 1029.6f, 866.1f, 1054.6f),
                        PathNode.QuadTo(822.7f, 1079.7f, 771.5f, 1079.7f),
                        PathNode.QuadTo(720.7f, 1079.7f, 677.7f, 1054.6f),
                        PathNode.QuadTo(634.7f, 1029.5f, 609.0f, 986.1f),
                        PathNode.QuadTo(583.2f, 942.7f, 583.2f, 891.5f),
                        PathNode.QuadTo(583.2f, 840.7f, 609.0f, 797.7f),
                        PathNode.QuadTo(634.7f, 754.7f, 677.7f, 729.0f),
                        PathNode.QuadTo(720.7f, 703.2f, 771.8f, 703.2f),
                        PathNode.QuadTo(822.8f, 703.2f, 866.2f, 729.0f),
                        PathNode.QuadTo(909.6f, 754.7f, 934.6f, 797.7f),
                        PathNode.QuadTo(959.7f, 840.7f, 959.7f, 891.8f),
                        PathNode.Close,
                        PathNode.MoveTo(684.5f, 891.5f),
                        PathNode.QuadTo(684.5f, 927.5f, 710.0f, 953.5f),
                        PathNode.QuadTo(735.4f, 979.4f, 771.5f, 979.4f),
                        PathNode.QuadTo(808.5f, 979.4f, 834.0f, 953.8f),
                        PathNode.QuadTo(859.4f, 928.1f, 859.4f, 891.8f),
                        PathNode.QuadTo(859.4f, 855.4f, 834.0f, 829.5f),
                        PathNode.QuadTo(808.5f, 803.5f, 771.5f, 803.5f),
                        PathNode.QuadTo(735.4f, 803.5f, 710.0f, 829.5f),
                        PathNode.QuadTo(684.5f, 855.4f, 684.5f, 891.5f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _tuneMedium!!
    }

private var _tuneMedium: ImageVector? = null

val COUIIcons.Demibold.Tune: ImageVector
    get() {
        if (_tuneDemibold != null) return _tuneDemibold!!
        _tuneDemibold = ImageVector.Builder(
            name = "Tune.Demibold",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1216.8f,
            viewportHeight = 1216.8f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1216.8f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(631.4f, 318.9f),
                        PathNode.QuadTo(631.4f, 371.4f, 605.5f, 416.1f),
                        PathNode.QuadTo(579.7f, 460.7f, 534.9f, 486.6f),
                        PathNode.QuadTo(490.2f, 512.4f, 437.4f, 512.4f),
                        PathNode.QuadTo(385.4f, 512.4f, 341.0f, 486.5f),
                        PathNode.QuadTo(296.5f, 460.7f, 270.0f, 415.9f),
                        PathNode.QuadTo(243.4f, 371.2f, 243.4f, 318.4f),
                        PathNode.QuadTo(243.4f, 266.4f, 270.0f, 222.0f),
                        PathNode.QuadTo(296.5f, 177.5f, 341.0f, 151.0f),
                        PathNode.QuadTo(385.4f, 124.4f, 437.9f, 124.4f),
                        PathNode.QuadTo(490.4f, 124.4f, 535.1f, 151.0f),
                        PathNode.QuadTo(579.7f, 177.5f, 605.6f, 222.0f),
                        PathNode.QuadTo(631.4f, 266.4f, 631.4f, 318.9f),
                        PathNode.Close,
                        PathNode.MoveTo(355.4f, 318.3f),
                        PathNode.QuadTo(355.4f, 352.4f, 379.4f, 376.9f),
                        PathNode.QuadTo(403.4f, 401.4f, 437.5f, 401.4f),
                        PathNode.QuadTo(472.4f, 401.4f, 496.4f, 377.4f),
                        PathNode.QuadTo(520.4f, 353.4f, 520.4f, 318.9f),
                        PathNode.QuadTo(520.4f, 284.4f, 496.4f, 259.9f),
                        PathNode.QuadTo(472.4f, 235.4f, 437.5f, 235.4f),
                        PathNode.QuadTo(403.4f, 235.4f, 379.4f, 259.8f),
                        PathNode.QuadTo(355.4f, 284.3f, 355.4f, 318.3f),
                        PathNode.Close,
                        PathNode.MoveTo(322.4f, 375.4f),
                        PathNode.HorizontalTo(143.4f),
                        PathNode.QuadTo(126.9f, 375.4f, 114.1f, 364.4f),
                        PathNode.QuadTo(101.4f, 353.4f, 101.4f, 330.4f),
                        PathNode.VerticalTo(307.4f),
                        PathNode.QuadTo(101.4f, 284.4f, 113.4f, 273.4f),
                        PathNode.QuadTo(125.4f, 262.4f, 143.4f, 262.4f),
                        PathNode.HorizontalTo(322.4f),
                        PathNode.Close,
                        PathNode.MoveTo(1115.4f, 307.4f),
                        PathNode.VerticalTo(330.4f),
                        PathNode.QuadTo(1115.4f, 353.4f, 1102.7f, 364.4f),
                        PathNode.QuadTo(1089.9f, 375.4f, 1073.4f, 375.4f),
                        PathNode.HorizontalTo(561.4f),
                        PathNode.VerticalTo(261.4f),
                        PathNode.LineTo(1073.4f, 262.4f),
                        PathNode.QuadTo(1091.4f, 262.4f, 1103.4f, 273.4f),
                        PathNode.QuadTo(1115.4f, 284.4f, 1115.4f, 307.4f),
                        PathNode.Close,
                        PathNode.MoveTo(1115.4f, 887.4f),
                        PathNode.VerticalTo(910.4f),
                        PathNode.QuadTo(1115.4f, 933.4f, 1102.7f, 944.4f),
                        PathNode.QuadTo(1089.9f, 955.4f, 1073.4f, 955.4f),
                        PathNode.HorizontalTo(894.4f),
                        PathNode.VerticalTo(842.4f),
                        PathNode.HorizontalTo(1073.4f),
                        PathNode.QuadTo(1091.4f, 842.4f, 1103.4f, 853.4f),
                        PathNode.QuadTo(1115.4f, 864.4f, 1115.4f, 887.4f),
                        PathNode.Close,
                        PathNode.MoveTo(655.4f, 955.4f),
                        PathNode.HorizontalTo(143.4f),
                        PathNode.QuadTo(126.9f, 955.4f, 114.1f, 944.4f),
                        PathNode.QuadTo(101.4f, 933.4f, 101.4f, 910.4f),
                        PathNode.VerticalTo(887.4f),
                        PathNode.QuadTo(101.4f, 864.4f, 113.4f, 853.4f),
                        PathNode.QuadTo(125.4f, 842.4f, 143.4f, 842.4f),
                        PathNode.HorizontalTo(655.4f),
                        PathNode.Close,
                        PathNode.MoveTo(972.4f, 898.9f),
                        PathNode.QuadTo(972.4f, 951.4f, 946.5f, 996.1f),
                        PathNode.QuadTo(920.7f, 1040.7f, 875.9f, 1066.6f),
                        PathNode.QuadTo(831.2f, 1092.4f, 778.4f, 1092.4f),
                        PathNode.QuadTo(726.4f, 1092.4f, 682.0f, 1066.5f),
                        PathNode.QuadTo(637.5f, 1040.7f, 611.0f, 995.9f),
                        PathNode.QuadTo(584.4f, 951.2f, 584.4f, 898.4f),
                        PathNode.QuadTo(584.4f, 846.4f, 611.0f, 802.0f),
                        PathNode.QuadTo(637.5f, 757.5f, 682.0f, 731.0f),
                        PathNode.QuadTo(726.4f, 704.4f, 778.9f, 704.4f),
                        PathNode.QuadTo(831.4f, 704.4f, 876.1f, 731.0f),
                        PathNode.QuadTo(920.7f, 757.5f, 946.6f, 802.0f),
                        PathNode.QuadTo(972.4f, 846.4f, 972.4f, 898.9f),
                        PathNode.Close,
                        PathNode.MoveTo(696.4f, 898.3f),
                        PathNode.QuadTo(696.4f, 932.4f, 720.4f, 956.9f),
                        PathNode.QuadTo(744.4f, 981.4f, 778.5f, 981.4f),
                        PathNode.QuadTo(813.4f, 981.4f, 837.4f, 957.4f),
                        PathNode.QuadTo(861.4f, 933.4f, 861.4f, 898.9f),
                        PathNode.QuadTo(861.4f, 864.4f, 837.4f, 839.9f),
                        PathNode.QuadTo(813.4f, 815.4f, 778.5f, 815.4f),
                        PathNode.QuadTo(744.4f, 815.4f, 720.4f, 839.8f),
                        PathNode.QuadTo(696.4f, 864.3f, 696.4f, 898.3f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _tuneDemibold!!
    }

private var _tuneDemibold: ImageVector? = null
